<template>
	<div class="text-center pt-5">
		<span class="title">{{title}}</span>
		<br>
		<span v-if="description" class="description">{{description}}
			<br>
		</span>
		<span class="big-number">{{this.bigNumber}}</span>
	</div>
</template>

<script>
	export default {
		props: ['id', 'data'],
		data() {
			return {
				title: '',
				description: '',
				bigNumber: 0,
				field: '',
			}
		},
		created() {
			this.$store.dispatch('visualizations/fetchVisualization', this.data.idVisualization)
				.then((res) => {
					this.title = res.data.data.visualization.title;
					let data = JSON.parse(res.data.data.visualization.data);
					this.description = data.description;
					this.field = data.field;
					this.execute(res.data.data.visualization.query_id);
				})
		},
		beforeDestroy() {
			this.$store.commit('queries/SET_RESULTS', []);
		},
		methods: {
			execute(visualization_id) {
				this.$store.dispatch('queries/getResults', visualization_id)
					.then(() => {
						this.bigNumber = this.$store.state.queries.results[0][this.field];
					})
			},
		}
	}
</script>

<style scoped>
</style>
